var _excluded = ["captionId", "getHeaderGroups", "getRowModel", "onRowClick", "getRowAriaLabel", "isLoading", "hideHeaderWhileLoading", "loadingRowIds", "highlightedRowIds", "isHeaderSticky", "sortingState"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { flexRender } from '@tanstack/react-table';
import React from 'react';
import { Blanket } from '../../../feedback';
import { _Table, _TableBody, _TableDataCell, _TableHead, _TableHeaderBaseCell, _TableHeaderRow, _TableRow } from '../../../internal';
import { expandColumnId } from './table.utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DesktopTableComponent = (_ref, ref) => {
  var {
    captionId,
    getHeaderGroups,
    getRowModel,
    onRowClick,
    getRowAriaLabel,
    isLoading,
    hideHeaderWhileLoading,
    loadingRowIds = [],
    highlightedRowIds = [],
    isHeaderSticky,
    sortingState
  } = _ref,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var lastSubRowIds = [];
  var shouldShowTableHeaderWhileLoading = !isLoading || !hideHeaderWhileLoading;
  return /*#__PURE__*/_jsxs(_Table, _objectSpread(_objectSpread({}, restProps), {}, {
    ref: ref,
    isLoading: isLoading,
    isHeaderSticky: isHeaderSticky,
    "data-component": "Table",
    "aria-labelledby": captionId,
    children: [shouldShowTableHeaderWhileLoading && /*#__PURE__*/_jsx(_TableHead, {
      isHeaderSticky: isHeaderSticky,
      children: getHeaderGroups().map(headerGroup => /*#__PURE__*/_jsx(_TableHeaderRow, {
        children: headerGroup.headers.map(header => {
          var {
            size,
            textAlign,
            isSticky
          } = header.column.columnDef.meta;
          return /*#__PURE__*/_jsx(_TableHeaderBaseCell, {
            size: size,
            textAlign: textAlign,
            isSticky: isSticky,
            "data-testid": "table-header-cell-".concat(header.column.columnDef.id),
            sortDirection: (sortingState === null || sortingState === void 0 ? void 0 : sortingState.id) === header.id ? sortingState.sortDirection : undefined,
            children: flexRender(header.column.columnDef.header, header.getContext())
          }, header.id);
        })
      }, headerGroup.id))
    }), /*#__PURE__*/_jsx(_TableBody, {
      isLoading: isLoading,
      children: getRowModel().rows.map(row => {
        if (row.subRows.length > 0) {
          var _row$subRows;

          // This is needed in order to know `isLastSubRow` so we can remove the border from its 'expand' cell.
          var lastSubRowId = (_row$subRows = row.subRows[row.subRows.length - 1]) === null || _row$subRows === void 0 ? void 0 : _row$subRows.id;
          lastSubRowIds.push(lastSubRowId);
        }

        var rowIsLoading = loadingRowIds.includes(row.id);
        var isRowHighlighted = highlightedRowIds.includes(row.id);
        var isSubRow = row.depth > 0;
        var rowTestId = isSubRow ? "table-sub-row-".concat(row.id) : "table-row-".concat(row.id);
        return /*#__PURE__*/_jsx(_TableRow, {
          "aria-label": getRowAriaLabel === null || getRowAriaLabel === void 0 ? void 0 : getRowAriaLabel({
            rowId: row.id,
            rowData: row.original
          }),
          onClick: onRowClick ? () => onRowClick({
            rowId: row.id,
            rowData: row.original
          }) : undefined,
          isSubRow: isSubRow,
          isLastSubRow: lastSubRowIds.includes(row.id),
          "data-testid": rowTestId,
          isRowHighlighted: isRowHighlighted,
          children: row.getVisibleCells().map(cell => {
            var {
              size,
              textAlign,
              isSticky
            } = cell.column.columnDef.meta;
            var isNotExpandCellOnParentRow = !(row.depth === 0 && cell.id.includes(expandColumnId));
            return /*#__PURE__*/_jsxs(_TableDataCell, {
              size: size,
              textAlign: textAlign,
              isSticky: isSticky,
              children: [/*#__PURE__*/_jsx(Blanket, {
                variant: "light",
                isOpen: rowIsLoading && isNotExpandCellOnParentRow
              }), flexRender(cell.column.columnDef.cell, _objectSpread(_objectSpread({}, cell.getContext()), {}, {
                isLoading: rowIsLoading
              }))]
            }, cell.id);
          })
        }, row.id);
      })
    })]
  }));
};
export var DesktopTable = /*#__PURE__*/React.forwardRef(DesktopTableComponent);
DesktopTable.displayName = 'Table';
//# sourceMappingURL=DesktopTable.js.map